export default `/* Ids Pager Component */
:host(ids-pager),
.ids-pager {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 38px;
  margin: 6px 4px;
  width: calc(100% - 16px);
}
:host(ids-pager) .pager-section,
.ids-pager .pager-section {
  box-sizing: border-box;
  flex-basis: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-align: center;
}
:host(ids-pager) .pager-section.start, :host(ids-pager) .pager-section.end,
.ids-pager .pager-section.start,
.ids-pager .pager-section.end {
  flex-grow: 1;
}
:host(ids-pager) .pager-section.start,
.ids-pager .pager-section.start {
  justify-content: flex-start;
  text-align: left;
}
:host(ids-pager) .pager-section.end,
.ids-pager .pager-section.end {
  justify-content: flex-end;
  text-align: right;
}

.ids-pager-dropdown {
  --ids-button-tertiary-font-weight: var(--ids-font-weight-normal);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtcGFnZXIiLCJzb3VyY2VzIjpbImlkcy1wYWdlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7QUFBQTtFQUdFO0VBQ0E7RUFDQTtFQUdBO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0FBQUE7QUFBQTtFQUVFOztBQUdGO0FBQUE7RUFDRTtFQUNBOztBQUdGO0FBQUE7RUFDRTtFQUNBOzs7QUFLTjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFBhZ2VyIENvbXBvbmVudCAqL1xuOmhvc3QoaWRzLXBhZ2VyKSxcbi5pZHMtcGFnZXIge1xuICAvLyBBbGlnbm1lbnQgYW5kIERpc3BsYXlcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgLy8gU2l6aW5nXG4gIGhlaWdodDogMzhweDtcbiAgbWFyZ2luOiA2cHggNHB4O1xuICB3aWR0aDogY2FsYygxMDAlIC0gMTZweCk7XG5cbiAgLnBhZ2VyLXNlY3Rpb24ge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgZmxleC1iYXNpczogMDtcbiAgICBmbGV4LXNocmluazogMDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcblxuICAgICYuc3RhcnQsXG4gICAgJi5lbmQge1xuICAgICAgZmxleC1ncm93OiAxO1xuICAgIH1cblxuICAgICYuc3RhcnQge1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICAgICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICB9XG5cbiAgICAmLmVuZCB7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgICAgdGV4dC1hbGlnbjogcmlnaHQ7XG4gICAgfVxuICB9XG59XG5cbi5pZHMtcGFnZXItZHJvcGRvd24ge1xuICAtLWlkcy1idXR0b24tdGVydGlhcnktZm9udC13ZWlnaHQ6IHZhcigtLWlkcy1mb250LXdlaWdodC1ub3JtYWwpO1xufVxuIl19 */`;
